module.exports = __webpack_public_path__ + "static/media/apostle.c409ce6a.jpg";